@if (data.isfragmentable) {

  @if (candidatureTotalCount > 0) {
    <div class="fs-13">{{candidatureTotalCount}}</div>
  } @else {
    <div class="fs-11 text-neutral-dark-grey">Aucun candidat</div>
  }

} @else {
  <div >
    @if (indexAcceptedCandidate > -1) {
    <div class="user-container">
      <img [src]="displayImg(candidatList[indexAcceptedCandidate].candidatePhoto)" class="img size-sm" alt="user_img">
      <div>
        <div class="fs-13 fw-4" [matTooltip]="candidatList[indexAcceptedCandidate].candidateName">
          {{textSubstring(candidatList[indexAcceptedCandidate].candidateName, 7) }}</div>
      </div>
    </div>

    } @else if (candidatList.length >= 1) {
    <div class="fs-13">{{candidatList.length}}</div>
    } @else if (candidatList.length == 0) {
  <!--  <div class="fs-13">Auto</div>-->
    <div class="fs-11 text-neutral-dark-grey">Aucun candidat</div>
    }
  </div>
}

